import React from 'react';
import Eyebrow from './Eyebrow';

interface SectionProps {
  eyebrow?: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  meta?: React.ReactNode;
  tight?: boolean;
  children: React.ReactNode;
  className?: string;
  id?: string;
}

const Section: React.FC<SectionProps> = ({
  eyebrow,
  title,
  description,
  meta,
  tight,
  children,
  className = '',
  id,
}) => {
  const hasHead = eyebrow || title || description || meta;
  return (
    <section id={id} className={`ds-section ${tight ? 'ds-section--tight' : ''} ${className}`.trim()}>
      <div className="ds-wrap">
        {hasHead && (
          <div className="ds-section__head">
            <div className="ds-section__head-left">
              {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
              {title && <h2>{title}</h2>}
              {description && <p>{description}</p>}
            </div>
            {meta && <div className="ds-section__head-meta">{meta}</div>}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export default Section;
